<template>
  <main class="wh-full flex-1">
    <article class="gap h-full max-w-lvw min-h-[300px] flex-col flex-1 overflow-x-hidden">
      <template v-for="element in Data" v-if="Data.length">
        <component
          :is="`blocks-${element.component}`"
          :id="element.id"
          :datas="element.settings"
          :style="elementStyle(element.settings)"
          :class="`${element.disabled ? 'hidden!' : ''}`"
          class="page text-wrap-global px-2.5 md:mx-auto"
        />
      </template>
      <LazyErrorsRoutingNotFound v-else />
      <Breadcrumb />
    </article>
  </main>
</template>

<script setup lang="ts">
import picomatch from 'picomatch'
import { getPagesDetailAPI } from '~/services/api/pages'
import { elementStyle } from '~/utils/common/elementStyle'

defineOptions({
  name: 'PageResolver',
})

const route = useRoute()
const isMobile = useIsMobile()
const getCumtomPages = async () => {
  if (route.query.isPreview) {
    return {
      page: {
        title: 'Custom Pages',
        content: 'Custom Pages Content',
      },
    }
  }

  if (!route.path.includes('/pages')) {
    return null
  }

  // 预览模式

  // 正常模式
  const { data } = await getPagesDetailAPI(route.params.all[1])

  return data?.data
}

/**  获取页面路由 */
const { data: customPages } = await useAsyncData(`customPages${route.params?.all[1]}`, async () => await getCumtomPages(), {
  lazy: false,
  watch: [() => route.params?.all[1]],
})

provide('customPages', customPages)

const { pageRouter, page } = storeToRefs(useThemeEditorStore())

const Data = computed(() => {
  let blocks

  // 预览模式
  if (route.query.isPreview) {
    // 自定义模板--自定义页面

    // 正常模板
    // @ts-ignore
    blocks = page.value?.templates?.props?.blocks
  }

  // 正常模式
  else {
    const temp = pageRouter.value?.find((item: any) => picomatch.isMatch(route.path, item?.path || ''))?.props?.blocks

    // 自定义模块--自定义页面
    if (route.path.includes('/pages')) {
      const customPagesData = customPages.value as API.CustomTemplate

      blocks
        = (customPagesData?.template?.props?.blocks
          && Array.isArray(customPagesData.template?.props?.blocks)
          && customPagesData?.template?.props?.blocks?.length > 0)
          ? customPagesData?.template?.props?.blocks
          : temp
    }
    else {
      blocks = temp
    }
  }

  // 返回模板信息
  return Array.isArray(blocks) ? blocks.filter(i => !i.disabled) : []
})

// 使用导入的公用 elementStyle 函数
</script>

<style lang="scss" scoped>
.gap {
  gap: calc(var(--verticalGap) * 1px);
}
</style>
